import React, { useState } from "react";
import client from "../api/client";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
    Box,
    Button,
    Checkbox,
    Container,
    FormControlLabel,
    Grid,
    TextField,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

const SignUpforFreeChapter = () => {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        agree: false,
    });
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);
        if (!form.firstName || !form.lastName || !form.email || !form.agree) {
            setStatus("Please fill required fields and agree to emails.");
            return;
        }
        setLoading(true);
        try {
            // Call both endpoints sequentially (fire-and-forget style)
            await client.post('/free-chapter', {
                firstName: form.firstName.trim(),
                lastName: form.lastName.trim(),
                email: form.email.trim()
            });
            // await client.post('/request-tool', {
            //     firstName: form.firstName.trim(),
            //     lastName: form.lastName.trim(),
            //     email: form.email.trim()
            // });
            setStatus("Sent! Check your inbox for the free chapter + tools PDF.");
            setForm({ firstName: "", lastName: "", email: "", agree: false });
        } catch (err) {
            setStatus("Could not send resources. Please retry later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ bgcolor: "custom.yellow", py: 6, width: "100%" }}>
            <Container maxWidth="md">
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={4}>
                        <Typography
                            variant="h4"
                            component="h2"
                            
                            fontWeight={400}
                            gutterBottom
                        >
                            Sign up to our{" "}
                            <span style={{ textDecoration: "underline", fontWeight: 700, fontStyle: "italic" }}>
                                FREE
                            </span>{" "}
                            Chapter &amp; Tools From The CYJ-Positive Psychology Kids' Program - "My Family"
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <form onSubmit={handleSubmit}>
                            <Typography variant="h4" mb={2}>
                                Receive actionable steps to your inbox!
                            </Typography>
                            <Box mb={2}>
                                <Typography variant="body1" mb={0.5}>
                                    First name
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="firstName"
                                    placeholder="First name"
                                    value={form.firstName}
                                    onChange={handleChange}
                                    inputProps={{ style: { fontSize: 18 } }}
                                    InputProps={{
                                        style: { background: "#fff" }
                                    }}
                                    FormHelperTextProps={{
                                        style: { color: "#000" }
                                    }}
                                    sx={{
                                        "& input::placeholder": {
                                            color: "#000",
                                            opacity: 1,
                                            background: "#fff"
                                        }
                                    }}
                                />
                            </Box>
                            <Box mb={2}>
                                <Typography variant="body1" mb={0.5}>
                                    Last name
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="lastName"
                                    placeholder="Last name"
                                    value={form.lastName}
                                    onChange={handleChange}
                                    inputProps={{ style: { fontSize: 18 } }}
                                    InputProps={{
                                        style: { background: "#fff" }
                                    }}
                                    sx={{
                                        "& input::placeholder": {
                                            color: "#000",
                                            opacity: 1,
                                            background: "#fff"
                                        }
                                    }}
                                />
                            </Box>
                            <Box mb={2}>
                                <Typography variant="body1" mb={0.5}>
                                    Phone number
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="phone"
                                    type="tel"
                                    placeholder="Phone number"
                                    value={form.phone || ""}
                                    onChange={handleChange}
                                    inputProps={{ style: { fontSize: 18 } }}
                                    InputProps={{
                                        style: { background: "#fff" }
                                    }}
                                    sx={{
                                        "& input::placeholder": {
                                            color: "#000",
                                            opacity: 1,
                                            background: "#fff"
                                        }
                                    }}
                                />
                            </Box>
                            <Box mb={2}>
                                <Typography variant="body1" mb={0.5} >
                                    Your email
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="email"
                                    type="email"
                                    placeholder="Email"
                                    value={form.email}
                                    onChange={handleChange}
                                    inputProps={{ style: { fontSize: 18 } }}
                                    InputProps={{
                                        style: { background: "#fff" }
                                    }}
                                    sx={{
                                        "& input::placeholder": {
                                            color: "#000",
                                            opacity: 1,
                                            background: "#fff"
                                        }
                                    }}
                                />
                            </Box>
                            <List dense>
                                <ListItem disableGutters>
                                    <ListItemIcon sx={{ minWidth: 32 }}>
                                        <LockOutlinedIcon fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Yes, I agree to receive emails from you"
                                        primaryTypographyProps={{ fontSize: 18 }}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="agree"
                                                checked={form.agree}
                                                onChange={handleChange}
                                                required
                                            />
                                        }
                                        label=""
                                        sx={{ ml: 1 }}
                                    />
                                </ListItem>
                            </List>
                            <Box mt={3}>
                                {status && (
                                    <Typography
                                        variant="body2"
                                        color={"black"}
                                        sx={{ mb: 2, fontWeight: 600 }}
                                    >
                                        {status}
                                    </Typography>
                                )}
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    disabled={loading}
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: 20,
                                        px: 4,
                                    }}
                                    fullWidth
                                >
                                    {loading ? 'Sending...' : 'Yes! Send Chapter + Tools'}
                                </Button>
                            </Box>
                        </form>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default SignUpforFreeChapter;
